import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15 4.127a8 8 0 0 1 .95 4.763.866.866 0 1 1-1.722-.193 6.265 6.265 0 0 0-7.277-6.876 6.268 6.268 0 0 0-4.6 8.893 6.27 6.27 0 0 0 6.345 3.512.866.866 0 0 1 .192 1.722A8 8 0 0 1 .114 6.655 7.998 7.998 0 0 1 11.47.792 8 8 0 0 1 15 4.127m.933 8.96a.87.87 0 0 1-.8.536H13.62v1.51a.866.866 0 0 1-1.479.613L9.766 13.37a.87.87 0 0 1-.254-.613v-2.018L8.387 9.614A1.658 1.658 0 1 1 9.612 8.39l1.124 1.124h2.019c.23 0 .45.09.612.253l2.378 2.378c.248.248.322.62.188.944m-4.69-1.842v1.153l.646.645v-.287c0-.478.388-.866.866-.866h.286l-.645-.645zm.772-5.926c.53.794.813 1.727.813 2.682a.866.866 0 1 1-1.732 0A3.096 3.096 0 1 0 8 11.098a.866.866 0 1 1 0 1.732 4.83 4.83 0 1 1 4.016-7.511",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }